module.exports = __webpack_public_path__ + "img/logo-300-light.32cf1cd9.png";